import { Location } from 'types';

export const HEATMAP_FILTER_VALUE = {
  allProductInstalls: 'all-products-installs',
  solarInstalls: 'solar-installs',
  batteryInstalls: 'battery-installs',
  solarBatteryInstalls: 'solar-battery-installs',
  electricVehicleInstalls: 'electric-vehicle-installs',
  electricCarNewInstalls: 'electric-car-new-installs',
  electricCarUsedInstalls: 'electric-car-used-installs',
  electricMotorbikeNewInstalls: 'electric-motorbike-new-installs',
  electricMotorbikeUsedInstalls: 'electric-motorbike-used-installs',
  evChargingInfrastructureInstalls: 'ev-charging-infrastructure-installs',
  efficientElectricStoveTopsInstalls: 'efficient-electric-stove-tops-installs',
  electricHeatingCoolingSystemsReverseCycleInstalls:
    'electric-heating-cooling-systems-reverse-cycle-installs',
  hotWaterHeatPumpInstalls: 'hot-water-heat-pumps-installs',
  hydronicHeatPumpInstalls: 'hydronic-heat-pumps-installs',
  insulationInstalls: 'insulation-installs',
  numberOfLoans: 'number-of-loans',
  totalLoanAmount: 'total-loan-amount',
  averageLoanAmount: 'average-loan-amount',
  averageSolarCapacity: 'average-solar-capacity'
};

export const getLocationsHeatMapValue = (
  locations: Location[],
  heatMapFilter: string
) => {
  switch (heatMapFilter) {
    // Popular Products Panel
    case HEATMAP_FILTER_VALUE.allProductInstalls:
      return locations.map((location) => location.numSettled);

    case HEATMAP_FILTER_VALUE.solarInstalls:
      return locations.map((location) => location.numSettledAllSolar);

    case HEATMAP_FILTER_VALUE.batteryInstalls:
      return locations.map((location) => location.numSettledAllBatteries);

    case HEATMAP_FILTER_VALUE.solarBatteryInstalls:
      return locations.map(
        (location) => location.numSettledSolarAndBatterySystem
      );

    case HEATMAP_FILTER_VALUE.electricVehicleInstalls:
      return locations.map(
        (location) => location.numSettledAllElectricVehicles
      );

    case HEATMAP_FILTER_VALUE.electricCarNewInstalls:
      return locations.map((location) => location.numSettledElectricCarNew);

    case HEATMAP_FILTER_VALUE.electricCarUsedInstalls:
      return locations.map((location) => location.numSettledElectricCarUsed);

    case HEATMAP_FILTER_VALUE.electricMotorbikeNewInstalls:
      return locations.map(
        (location) => location.numSettledElectricMotorbikeNew
      );

    case HEATMAP_FILTER_VALUE.electricMotorbikeUsedInstalls:
      return locations.map(
        (location) => location.numSettledElectricMotorbikeUsed
      );

    case HEATMAP_FILTER_VALUE.evChargingInfrastructureInstalls:
      return locations.map(
        (location) => location.numSettledEvChargingInfrastructure
      );

    case HEATMAP_FILTER_VALUE.efficientElectricStoveTopsInstalls:
      return locations.map(
        (location) => location.numSettledEfficientElectricStoveTops
      );

    case HEATMAP_FILTER_VALUE.electricHeatingCoolingSystemsReverseCycleInstalls:
      return locations.map(
        (location) =>
          location.numSettledElectricHeatingAndCoolingSystemsReverseCycle
      );

    case HEATMAP_FILTER_VALUE.hotWaterHeatPumpInstalls:
      return locations.map(
        (location) => location.numSettledHotWaterHeatPumpsHwhp
      );

    case HEATMAP_FILTER_VALUE.hydronicHeatPumpInstalls:
      return locations.map((location) => location.numSettledHydronicHeatPumps);

    case HEATMAP_FILTER_VALUE.insulationInstalls:
      return locations.map((location) => location.numSettledInsulation);

    // Loans Panel
    case HEATMAP_FILTER_VALUE.numberOfLoans:
      return locations.map((location) => location.numSettled);

    case HEATMAP_FILTER_VALUE.totalLoanAmount:
      return locations.map((location) => location.amountSettled);

    case HEATMAP_FILTER_VALUE.averageLoanAmount:
      return locations.map((location) => location.avgAmountSettled);

    // Solar Info Panel
    case HEATMAP_FILTER_VALUE.averageSolarCapacity:
      return locations.map(
        (location) => location.avgTotalPanelsCapacityKilowatt
      );

    default:
      return [];
  }
};
